// extracted by mini-css-extract-plugin
module.exports = {"tabsLand":"enquireMatchDetails_tabsLand__3ctk5"};